import script from "./EventCompleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCompleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./EventCompleteDialog.vue?vue&type=style&index=0&id=15d52126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d52126"]])

export default __exports__